import { AnalyticsContextValue } from "@swiggy-private/analytics";
import { SCREEN_NAME } from "./analytics";

interface ErrorState {
    errorMessage: string;
}

const impressionSendGiftVoucher = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER,
        action: "impression-send-gift-voucher",
    });
};

const clickAmount = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    payload: { amountCategory: string; offerCallout: string },
) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER,
        action: "click-amount",
        label: JSON.stringify(payload),
    });
};

const clickMessageBox = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER,
        action: "click-message-box",
    });
};

const clickFaqOnVoucherSelection = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER,
        action: "click-faq",
    });
};

const impressionGiftCardFormError = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    errorObj: ErrorState,
) => {
    impressionEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER,
        action: "impression-error",
        label: JSON.stringify(errorObj),
    });
};

const clickProceedToPay = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    payload: {
        originalAmount: string;
        discountedAmount: string;
        message: string;
    },
) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER,
        action: "click-proceed-to-pay",
        label: JSON.stringify(payload),
    });
};

const impressionScreenViewLottie = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "screen-view-lottie",
    });
};

const impressionSendGiftVoucherSuccess = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER_SUCCESS,
        action: "impression-send-gift-voucher-success",
    });
};

const clickShare = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER_SUCCESS,
        action: "click-share-link",
    });
};

// sender journey events
const clickFaqOnVoucherSuccess = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER_SUCCESS,
        action: "click-faq",
    });
};

const clickCloseButton = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER_SUCCESS,
        action: "click-close",
    });
};

const clickBackButtonOnVoucherSelection = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.SEND_GIFT_VOUCHER,
        action: "click-back",
    });
};

// redemption flow events in receiver journey
const clickAddVoucher = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "click-add-voucher",
    });
};

const impressionAddVoucher = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "impression-add-voucher",
    });
};

const impressionAddVoucherSuccess = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "impression-add-voucher-success",
    });
};

const impressionVoucherClaimedError = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "impression-voucher-claimed-error",
    });
};

const impressionVoucherExpiredError = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "impression-voucher-expired-error",
    });
};

const clickGoToHome = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "click-go-to-home",
    });
};

const clickStartOrdering = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.ADD_GIFT_VOUCHER,
        action: "click-start-ordering",
    });
};

export const getGiftCardAnalyticsEvents = (analyticsEvents: AnalyticsContextValue) => {
    return {
        ...analyticsEvents,
        impressionSendGiftVoucher,
        clickProceedToPay,
        impressionScreenViewLottie,
        clickShare,
        impressionGiftCardFormError,
        impressionSendGiftVoucherSuccess,
        clickAddVoucher,
        impressionAddVoucher,
        impressionAddVoucherSuccess,
        impressionVoucherClaimedError,
        impressionVoucherExpiredError,
        clickGoToHome,
        clickStartOrdering,
        clickFaqOnVoucherSuccess,
        clickCloseButton,
        clickBackButtonOnVoucherSelection,
        clickAmount,
        clickMessageBox,
        clickFaqOnVoucherSelection,
    };
};
